export const DOTLOTTIE_PLAYER_VERSION = "1.3.1"; 
export const LOTTIE_WEB_VERSION = "^5.10.0";
